import { useMutation } from '@tanstack/react-query';

import { customFetcher } from '../useFetch';

/**
 * Portal-Trigger im Ident-Service: fordert die angehakten Beteiligten auf, im
 * Mandantenportal Ausweis + Stammdaten selbst zu erfassen. Setzt das
 * Vorgangs-Flag `RequestClientData`, schreibt die pro-Mandant-Auswahl und
 * loest die Aufforderungs-Mail sofort aus (ohne kompletten Vorgangs-Save).
 * Der Vorgang wird direkt ins Mandantenportal synchronisiert, wo der
 * Erfassungs-Aufruf erscheint.
 */
export const useSetRequestClientData = () => {
  const {
    mutateAsync: setRequestClientData,
    isPending: isSettingRequestClientData,
  } = useMutation({
    mutationFn: ({
      idLegalTransaction,
      value,
      clientIds,
    }: {
      idLegalTransaction: number;
      value: boolean;
      /** Optional: idLegalClient der aufzufordernden Beteiligten. */
      clientIds?: number[];
    }) =>
      customFetcher({
        endpoint: `/legaltransaction/${idLegalTransaction}/requestClientData`,
        method: 'PUT',
        body: { value, ...(clientIds ? { clientIds } : {}) },
      }),
  });

  return { setRequestClientData, isSettingRequestClientData };
};
